// ServiceOS/frontend/src/components/common/Loader.js

import React from 'react';

const Loader = () => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-slate-50 dark:bg-slate-900">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500"></div>
            <span className="sr-only">Loading...</span>
        </div>
    );
};

export default Loader;